// extracted by mini-css-extract-plugin
module.exports = {"comp":"Banner_comp__RERXi"};